import { render, staticRenderFns } from "./DelegateModal.vue?vue&type=template&id=740d85d2&scoped=true"
import script from "./DelegateModal.vue?vue&type=script&lang=js"
export * from "./DelegateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740d85d2",
  null
  
)

export default component.exports